import { Injectable, OnInit } from '@angular/core';
import { PaginationEnum } from './enum/base.enum';

// Use @Injectable() to declare the RouteService class as an Injectable
@Injectable()
export class PaginationService implements OnInit {

  sortExpression = '';
  filterValues = [];
  startPage = 1;
  pageSize = PaginationEnum.PageSize;
  fromDate: Date;
  toDate: Date;

  constructor() {
  }

  ngOnInit() {
  }

  setDefaultPage() {
    this.startPage = 1;
    this.pageSize = PaginationEnum.PageSize;
    this.sortExpression = '';
    this.filterValues = [];
  }

  resetPagination() {
    this.startPage = 1;
    this.pageSize = PaginationEnum.PageSize;
    this.sortExpression = '';
  }

  setPageChange(event) {
    this.startPage = 1 + event.page;
    this.pageSize = event.rows;
  }

  getParams() {
    let pagination = {
      PageSize: this.pageSize,
      RunCount: true,
      StartPageNo: this.startPage,
      SortExpression: this.sortExpression
    };
    return Object.assign(pagination, this.filterValues);
  }

  setSortExpression(event) {
    this.sortExpression = '';
    if (event) {
      let orderBy = '';
      if (event.order === -1) {
        orderBy = 'desc';
      }
      this.sortExpression = event.field + ' ' + orderBy;
    }
  }

  getFilteredObject(data) {
    const obj = Object.keys(data).reduce((object, key) => {
       if (data[key]) {
         object[key] = data[key]
       }
       return object
     }, {});
     return obj;
   }


  setFilterValues(filtersObj) {
    this.resetPagination();
    let copy = Object.assign({}, filtersObj);
    // let copy2 = Object.assign({}, filtersObj);
    this._deleteEmptyProp(copy);
    this._matchFilterProps(copy);
    // Object.assign(this.filterValues, copy2);
  }


  setPaginationValues(pageSize: number) {
    this.pageSize = pageSize;
  }

  _matchFilterProps(obj) {
    // tslint:disable-next-line:forin
    for (const prop in obj) {
      const f = 'Filter.' + prop;
      if (this.filterValues[f] !== null && obj[prop] !== undefined) {
        this.filterValues[f] = obj[prop];
      }
    }
  }

  // _deleteAllProp(obj) {
  //   // tslint:disable-next-line:forin
  //   for (const prop in obj) {
  //     const f = 'Filter.' + prop;
  //     delete obj[prop];
  //     delete this.filterValues[f];
  //   }
  //   return obj;
  // }

  _deleteEmptyProp(obj) {
    // tslint:disable-next-line:forin
    for (const prop in obj) {
      const val = obj[prop];
      const f = 'Filter.' + prop;
      if (val === undefined || val === null || val.length === 0) {
        delete obj[prop];
        delete this.filterValues[f];
      }
    }
    return obj;
  }

  // _addPrefixToProp(obj) {
  //   // tslint:disable-next-line:forin
  //   for (const prop in obj) {
  //     obj['Filter.' + prop] = obj[prop];
  //     delete obj[prop];
  //   }
  //   return obj;
  // }
}